<template>
  <content-loader
    class="person-loader"
    :height="150"
    :width="100"
    :speed="2"
    primaryColor="#f3f3f3"
    secondaryColor="#fae4ec"
  >
    <circle cx="50" cy="50" r="50" />
    <rect x="0" y="122" rx="0" ry="0" width="100" height="18" />
  </content-loader>
</template>

<script>
import { ContentLoader } from "vue-content-loader";

export default {
  name: "PersonContentLoader",
  components: {
    ContentLoader
  }
};
</script>

<style scoped>
.person-loader {
  margin: 25px;
  width: 100px;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: auto;
}
</style>
